var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.info.operatedBy && _vm.product.info.supplierCode === 'jonview')?_c('div',{staticClass:"text-caption text--secondary"},[_vm._v("\n    "+_vm._s(_vm.$t('operated_by'))+": "+_vm._s(_vm.product.info.operatedBy)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }